export default __webpack_public_path__ + "static/media/hdfcergo-logo.1569cd46.png";